import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Users } from "lucide-react";
import { api } from "../lib/api";

export const OPEN_STATUSES = ["queued", "approved", "fulfilling", "pending", "waiting_inventory"];

const fmtEta = (s) => (s < 60 ? "under a minute" : `about ${Math.round(s / 60)} min`);

function announce(r) {
  if (r.status !== "fulfilled") return toast.error(r.note || "Your pull didn't go through — nothing was charged. Please request again.");
  if (r.push_error) return toast.warning(`${r.fulfilled} leads received, but not pushed: ${r.push_error}`);
  toast.success(`${r.fulfilled} leads pushed to Entrance${r.account_name ? ` in ${r.account_name}` : ""}${r.push?.campaign_name ? ` as "${r.push.campaign_name}"` : ""}`);
}

export default function PullLine({ rid, onDone }) {
  const [q, setQ] = useState(null);
  const done = useRef(false);
  const cb = useRef(onDone);
  cb.current = onDone;
  useEffect(() => {
    done.current = false;
    let alive = true;
    let timer;
    const tick = async () => {
      try {
        const r = (await api.get(`/rep-requests/${rid}/queue`)).data;
        if (!alive) return;
        setQ(r);
        const finished = !OPEN_STATUSES.includes(r.status) && (r.status !== "fulfilled" || r.push || r.push_error);
        if (finished) {
          if (!done.current) { done.current = true; announce(r); cb.current(); }
          return;
        }
      } catch { if (!alive) return; }
      timer = setTimeout(tick, 2000);
    };
    tick();
    return () => { alive = false; clearTimeout(timer); };
  }, [rid]);
  const inLine = !q || q.status === "queued";
  return (
    <div className="panel p-4 flex items-center gap-3 border-l-4 border-l-zinc-950" data-testid="pull-line-status">
      {inLine ? <Users className="w-5 h-5 shrink-0" /> : <Loader2 className="w-5 h-5 shrink-0 animate-spin" />}
      <div className="text-sm">
        {inLine && q ? (<><b data-testid="pull-line-position">You're #{q.position} in line</b>{q.account_name && <span> on {q.account_name}</span>} · <span data-testid="pull-line-eta">est. {fmtEta(q.eta_seconds)}</span>
          <div className="text-[11px] text-zinc-500">You can leave this page — your {q.requested} leads will go out to Entrance automatically when it's your turn.</div></>)
          : <b data-testid="pull-line-filling">{q?.status === "fulfilled" ? "Pushing your leads to Entrance…" : `Filling your ${q?.requested ?? ""} leads now…`}</b>}
      </div>
    </div>
  );
}
